import React, { useMemo } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

// Chakra imports
import {
  Avatar,
  Badge,
  Icon,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Progress,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";

// Custom components
import Card from "components/card/Card.js";
import Menu from "components/menu/MainMenu";


// Assets
import { MdEdit } from "react-icons/md";

function ManagementTable(props) {

  const { astronautsData } = props;


  const textColor = useColorModeValue("navy.700", "white");
  const borderColor = useColorModeValue("secondaryGray.400", "whiteAlpha.100");

  const tableColumns = ['Astronaut', 'Today', 'Last 7 Days', 'Last 14 Days', 'Last 30 Days'];

  const getPercentColor = (value) => {

    if( value >= 0 && value <= 32 )
        return 'pink';
    else if( value >= 33 && value <= 66 )
        return 'yellow';
    else if ( value >= 67 && value <= 99 )
        return 'cyan';
    else
        return 'green';

    return color;
  }

  return (
    <Card>
      <Flex
        direction='column'
        w='100%'
        overflowX={{ sm: "scroll", lg: "hidden" }}>
        <Flex
          align={{ lg: "center" }}
          justify={{ base: "space-between" }}
          w='100%'
          px='20px'
          mb='20px'>
          <Text
            color={textColor}
            fontSize='xl'
            fontWeight='600'
            lineHeight='100%'>
            Time Staking
          </Text>
        </Flex>

        <Table variant='simple' color='gray.500'>
          <Thead>
              <Tr>
                { tableColumns.map((column) =>
                  <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color='gray.400'>
                    {column}
                  </Flex>
                </Th>
                )}
              </Tr>
          </Thead>


          <Tbody>

          { astronautsData == null && (
            <>
            <Tr>
                <Td
                            colSpan='4'
                            fontSize={{ sm: "14px" }}
                            minW={{ sm: "120px", md: "200px", lg: "auto" }}
                            borderColor='transparent'
                            mt='20px !important'
                            py='10px !important'>

                            <Text
                              color={textColor}
                              fontSize='lg'
                              fontWeight='700'>
                              There are no astronauts in mission. Make sure you own at least one and wait for the next boarding.
                            </Text>
                </Td>
            </Tr>
            </>
          )}

          {astronautsData && Object.keys(astronautsData).map((astronaut, key) =>
            <Tr key={key}>
                <Td
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "120px", md: "200px", lg: "auto" }}
                        borderColor='transparent'
                        mt='20px !important'
                        py='10px !important'>

                        <Flex align='center'>
                          <Avatar
                            src={ astronautsData[astronaut]['image'] }
                            w='80px'
                            h='80px'
                            me='28px'
                            borderRadius='14px'
                          />
                          <Flex direction='column'>
                            <Text
                              color={textColor}
                              fontSize='lg'
                              fontWeight='700'>
                              { astronautsData[astronaut]['name'] }
                            </Text>
                          </Flex>
                        </Flex>
                </Td>

                <Td
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "120px", md: "200px", lg: "auto" }}
                        borderColor='transparent'
                        mt='20px !important'
                        py='10px !important'>

                        <Flex direction='column'>
                        <Text color={textColor} fontSize='lg' fontWeight='600' mb='8px'>
                          { astronautsData[astronaut]['today']['percent'] !== null ? astronautsData[astronaut]['today']['percent'] + '%' : 'disabled' }
                        </Text>

                        <Progress value={ astronautsData[astronaut]['today']['percent'] } size="md" minW={{ lg: "80px" }} colorScheme={getPercentColor(astronautsData[astronaut]['today']['percent'])} isAnimated="true" hasStripe />
                        </Flex>
                </Td>

                <Td
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "120px", md: "200px", lg: "auto" }}
                        borderColor='transparent'
                        mt='20px !important'
                        py='10px !important'>

                        <Flex direction='column'>
                        <Text color={textColor} fontSize='lg' fontWeight='600' mb='8px'>
                            { astronautsData[astronaut]['last7Days']['percent'] !== null ? astronautsData[astronaut]['last7Days']['percent'] + '%' : 'disabled' }
                        </Text>

                        <Progress value={ astronautsData[astronaut]['last7Days']['percent'] } size="md" minW={{ lg: "80px" }} colorScheme={getPercentColor(astronautsData[astronaut]['last7Days']['percent'])} isAnimated="true" hasStripe />
                        </Flex>
                </Td>

                <Td
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "120px", md: "200px", lg: "auto" }}
                        borderColor='transparent'
                        mt='20px !important'
                        py='10px !important'>

                        <Flex direction='column'>
                        <Text color={textColor} fontSize='lg' fontWeight='600' mb='8px'>
                          { astronautsData[astronaut]['last14Days']['percent'] !== null ? astronautsData[astronaut]['last7Days']['percent'] + '%' : 'disabled' }
                        </Text>

                        <Progress value={ astronautsData[astronaut]['last14Days']['percent'] } size="md" minW={{ lg: "80px" }} colorScheme={getPercentColor(astronautsData[astronaut]['last14Days']['percent'])} isAnimated="true" hasStripe />
                        </Flex>
                </Td>

                <Td
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "120px", md: "200px", lg: "auto" }}
                        borderColor='transparent'
                        mt='20px !important'
                        py='10px !important'>

                        <Flex direction='column'>
                        <Text color={textColor} fontSize='lg' fontWeight='600' mb='8px'>
                          { astronautsData[astronaut]['last30Days']['percent'] !== null ? astronautsData[astronaut]['last7Days']['percent'] + '%' : 'disabled' }
                        </Text>

                        <Progress value={ astronautsData[astronaut]['last30Days']['percent'] } size="md" minW={{ lg: "80px" }} colorScheme={getPercentColor(astronautsData[astronaut]['last30Days']['percent'])} isAnimated="true" hasStripe />
                        </Flex>
                </Td>
            </Tr>
            )}

          </Tbody>

        </Table>

      </Flex>
    </Card>
  );
}

export default ManagementTable;
